import {h, Component} from 'preact';
import {Field} from 'formik';
import cx from 'classnames';

export const Radio = props =>
    <Field name={props.name}>
        {( {field, form} ) => {
            const isChecked = field.value && field.value.includes( props.value );
            const checkboxClasses = cx( 'radio', {'checked': isChecked} );
            const radioField =
                <span className={cx( props.inputClassName, 'wrap-check' )}>
                    <input
                        type="radio"
                        name={props.name}
                        value={props.value}
                        checked={isChecked}
                        onChange={form.handleChange}
                        onBlur={form.handleBlur}/>
                    <span className={checkboxClasses}></span>
                </span>;

            if ( typeof props.children[0] === 'function' ) {
                return (
                    <label className="font-normal">
                        {props.children[0]( {radioField} )}
                    </label>
                );
            }

            return (
                <label className="font-normal">
                    {radioField}
                    {props.label}
                </label>
            );
        }}
    </Field>;